import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SmRadioComponent } from './sm-radio.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SmErrorModule } from '../sm-error/sm-error.module';
// import { SmErrorModule } from '../sm-error/sm-error.module';

@NgModule({
    declarations: [SmRadioComponent],
    imports: [CommonModule, FormsModule, ReactiveFormsModule,SmErrorModule],
    exports: [SmRadioComponent]
})
export class SmRadioModule {}
